jQuery(document).ready(function($){
    $(document).on('click', '.textImageSection__volumeButton', function () {
        $(this).toggleClass('unmuted');
        $(this).parents('.textImageSection').find('video').get(0).muted = !$(this).hasClass('unmuted');
    })
});